export default{
    proveedores: [],
    proveedorSelec: null,
    totalProveedores: 0,

    reglaSelec: null,

    regimenes: [],
    categorias: [],
    tiposHabitacion: [],
    caracteristicasHabitacion: [],
    puntosProveedores: [],

   
}